import axios from "axios";

import {HOST_URL, LOCAL_STORAGE_TOKEN_KEY} from "../../../consts";
import {editProjectStarted} from "./editProjectStartedAction";
import {editProjectError} from "./editProjectErrorAction";
import {unauthorizedError} from "../../signin/unauthorizedErrorAction";
import {getProjectSettingsSuccess} from "./getProjectSettingsSuccessAction";

export function getProjectSettings(projectId) {
    let authToken = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);

    return function (dispatch) {
        let url = HOST_URL+'/api/settings/' + projectId;

        dispatch(editProjectStarted());

        return axios.get(url,{headers: {Authorization: authToken}}).then((response) => {
            if (response.data.success) {

                dispatch(getProjectSettingsSuccess(response.data.project));
            }
            else {
                dispatch(editProjectError(new Error(response.data.message)));
            }
        }).catch(error => {
            if (error.response && error.response.status ===401)
                return dispatch(unauthorizedError());

            console.log(error.message);
            dispatch(editProjectError(error));
        });
    };


}